module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.0","quantity":0},{"color":"#9dc4b5","label":" 0.0- 0.1012","quantity":0.00101},{"color":"#e6efc3","label":" 0.1012- 0.3304","quantity":0.0033},{"color":"#ffe89e","label":" 0.3304- 0.74319","quantity":0.00743},{"color":"#f5af7f","label":" 0.74319- 1.62039","quantity":0.0162},{"color":"#ed6d32","label":" 1.62039- 12.4064","quantity":0.12406}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_70.json
// module id = Qn/j
// module chunks = 171